export default __webpack_public_path__ + "static/media/5.da5f6358.jpg";